import { useState } from "react";
import axios from "axios";

export default function UserMessage() {

  const [body, setBody] = useState("");
  const [msg, setMsg] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    axios.post(
      `/api/user/message`,
      { body },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(res => {
      setMsg(res.data.message);
      setBody("");
    })
    .catch(() => setMsg("Greška pri slanju poruke ❌"));
  };

  return (
  <div className="container mt-5">

    <div
      className="p-5 rounded-4"
      style={{
        background: "rgba(255,255,255,0.03)",
        backdropFilter: "blur(20px)",
        border: "1px solid rgba(255,255,255,0.08)",
        color: "#fff",
        maxWidth: "700px"
      }}
    >

      {/* Header */}
      <div className="mb-4">
        <h2 className="fw-semibold mb-2">Kontaktirajte nas</h2>
        <p style={{ color: "rgba(255,255,255,0.6)" }}>
          Pošaljite poruku našem timu. Odgovaramo u najkraćem roku.
        </p>
      </div>

      {/* Status message */}
      {msg && (
        <div
          className="mb-4 px-4 py-2 rounded-pill text-center"
          style={{
            fontSize: "14px",
            fontWeight: "500",
            background: msg.includes("Greška")
              ? "linear-gradient(135deg,#ef4444,#b91c1c)"
              : "linear-gradient(135deg,#22c55e,#15803d)",
            color: "#fff"
          }}
        >
          {msg}
        </div>
      )}

      <form onSubmit={handleSubmit}>

        {/* Textarea */}
        <div className="mb-4">
          <label
            className="mb-2"
            style={{ color: "rgba(255,255,255,0.7)", fontSize: "14px" }}
          >
            Vaša poruka
          </label>

          <textarea
            rows="5"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            required
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "12px",
              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#fff",
              resize: "none",
              outline: "none",
              transition: "all 0.3s ease"
            }}
            onFocus={e => {
              e.target.style.border = "1px solid #4f46e5";
              e.target.style.boxShadow = "0 0 0 3px rgba(79,70,229,0.3)";
            }}
            onBlur={e => {
              e.target.style.border = "1px solid rgba(255,255,255,0.08)";
              e.target.style.boxShadow = "none";
            }}
          />
        </div>

        {/* Button */}
        <button
          type="submit"
          style={{
            padding: "12px 28px",
            borderRadius: "999px",
            border: "none",
            fontWeight: "500",
            background: "linear-gradient(135deg,#4f46e5,#9333ea)",
            color: "#fff",
            transition: "all 0.3s ease"
          }}
          onMouseEnter={e => {
            e.target.style.transform = "translateY(-2px)";
            e.target.style.boxShadow = "0 10px 25px rgba(147,51,234,0.4)";
          }}
          onMouseLeave={e => {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "none";
          }}
        >
          Pošalji poruku
        </button>

      </form>
    </div>
  </div>
  );
}